import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function ProductSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="text-xs font-semibold tracking-widest uppercase text-primary-600">
              产品服务
            </span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-foreground-950">
              全方位 <strong>产品与服务</strong> 矩阵
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              覆盖智能家居、企业服务、健康科技、教育科技四大领域
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8" data-product-shop>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/categories`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="p-6 md:p-8">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                      <i className={`${cat.icon} text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg md:text-xl font-semibold text-foreground-950">
                        {cat.name}
                      </h3>
                      <p className="mt-1 text-sm text-foreground-600">
                        {cat.products.length} 款产品
                      </p>
                    </div>
                  </div>
                  <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {cat.products.slice(0, 3).map((p) => (
                      <span
                        key={p.id}
                        className="px-3 py-1 text-xs rounded-full bg-background-100 text-foreground-600 border border-background-200 whitespace-nowrap"
                      >
                        {p.name}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className="mt-10 text-center">
            <Link
              to="/categories"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              查看全部产品
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}